import { useEffect } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchTime = (assignappId) => {
  const { apiGet } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  useEffect(() => {
    if (!assignappId) return;
    startLoading();
    const fetchData = async () => {
      const response = await apiGet(`/assignapps/${assignappId}/get_time`, "Error al obtener el tiempo");
      setResponse(response);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignappId]);

  return { data, error, loading };
};

export default useFetchTime;
